import React from "react";

import Form from "antd/lib/form";
import Input from "antd/lib/input";
import InputNumber from "antd/lib/input-number";
import Button from "antd/lib/button";
import Spin from "antd/lib/spin";
import Alert from "antd/lib/alert";
import Select from "antd/lib/select";
import DatePicker from "antd/lib/date-picker";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Typography from "antd/lib/typography";
import Tooltip from "antd/lib/tooltip";
import Icon from "antd/lib/icon";
import Divider from "antd/lib/divider";
import numeral from "numeral";
import mime from "mime-types";

import SelectFile from "./SelectFile";

import countries from "utils/countries";

const { Option } = Select;
const { Title } = Typography;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const infoIcon = (info) => (
  <Tooltip title={info} placement="topRight">
    <Icon type="info-circle" style={{ color: "rgba(0,0,0,.45)" }} />
  </Tooltip>
);

const getInfo = ({ prefix, info, placeholder, disabled, viewOnly }) => ({
  placeholder,
  disabled: viewOnly || (!viewOnly && disabled),
  className: viewOnly ? "form-view-only" : "",
  addonBefore: prefix,
  ...(info === null
    ? {}
    : {
        suffixIcon: infoIcon(info),
        suffix: infoIcon(info),
      }),
});

const handlePhone = (value) => {
  let matches = [];

  countries.map((country) => {
    let d_code = country.dial_code.replace("+", "");
    if (value !== null && value !== "" && value.startsWith(d_code)) {
      matches.push(d_code);
    }
    return country;
  });

  if (matches.length === 0) matches.push("250");

  matches.sort(function (a, b) {
    if (a.length < b.length) {
      return -1;
    }
    if (a.length > b.length) {
      return 1;
    }

    return 0;
  });

  let phone = {
    dial_code: value === null || value === "" ? "250" : matches[0],
    value:
      value === null || value === "" ? "" : value.substring(matches[0].length),
  };

  return phone;
};

const Dt = (opts) => {
  let {
    name = "input",
    placeholder = "",
    info = null,
    prefix = null,
    label = null,
    type = "text",
    message = "",
    rules = [],
    value = null,
    multiline = false,
    password = false,
    select = false,
    file = false,
    options = [],
    mode = "default",
    number = false,
    date = false,
    phone = false,
    separator = null,
    component = null,
    disabled = false,
    index = 0,
    AlertWrapper = null,
    noLabels = false,
    labelsTop = false,
    getFieldDecorator = null,
    showIf = null,
    hideIf = null,
    validIfEqual = null,
    getFieldValue = null,
    loading = false,
    error = "",
    retry = null,
    viewOnly = false,
    onChange,
  } = opts;

  let show = true;

  if (showIf !== null) {
    if (typeof showIf === "boolean") {
      show = showIf;
    } else {
      if (showIf.name) {
        if (
          getFieldValue(showIf.name) !== showIf.value &&
          !showIf.value.includes(getFieldValue(showIf.name))
        ) {
          show = false;
        }
      }
      if (showIf[0]) {
        showIf.map((shIf) => {
          if (shIf.name) {
            if (
              getFieldValue(shIf.name) !== shIf.value &&
              !shIf.value.includes(getFieldValue(shIf.name))
            ) {
              show = false;
            }
          }
          return shIf;
        });
      }
    }
  }

  if (hideIf !== null) {
    if (typeof hideIf === "boolean") {
      show = !hideIf;
    } else {
      if (hideIf.name) {
        if (
          getFieldValue(hideIf.name) === hideIf.value ||
          hideIf.value.includes(getFieldValue(hideIf.name))
        ) {
          show = false;
        }
      }
      if (hideIf[0]) {
        hideIf.map((hiIf) => {
          if (hiIf.name) {
            if (
              getFieldValue(hiIf.name) === hiIf.value ||
              hiIf.value.includes(getFieldValue(hiIf.name))
            ) {
              show = false;
            }
          }
          return hiIf;
        });
      }
    }
  }

  let prefixSelector = null;

  // if (phone) {
  //   prefixSelector = <span>+{handlePhone(value).dial_code}</span>;
  // }

  if (!show) {
    return null;
  } else {
    return component ? (
      component
    ) : separator ? (
      <AlertWrapper
        labelsTop={labelsTop}
        style={{
          marginTop: index > 0 ? 16 : 0,
        }}
      >
        <Title level={4}>{separator}</Title>
      </AlertWrapper>
    ) : (
      <Form.Item
        key={name}
        {...(message === "" && error === ""
          ? {}
          : {
              extra: (
                <>
                  {message}
                  {error !== "" && (
                    <Alert
                      message="Error!"
                      description={error}
                      type="error"
                      showIcon
                      {...(retry
                        ? {
                            closable: true,
                            closeText: "RETRY",
                            onClose: { retry },
                          }
                        : {})}
                    />
                  )}
                </>
              ),
            })}
        {...(noLabels
          ? {}
          : {
              label: label || placeholder.replace("...", ""),
              ...(labelsTop
                ? {
                    labelCol: { span: 24 },
                    wrapperCol: { span: 24 },
                    labelAlign: "left",
                  }
                : {}),
            })}
      >
        {getFieldDecorator(name, {
          initialValue:
            prefixSelector === null ? value : handlePhone(value).value,
          type,
          rules: [
            ...rules,
            ...(validIfEqual
              ? [
                  {
                    validator: (rule, value__, callback) => {
                      if (value__ !== getFieldValue(validIfEqual.value)) {
                        callback(validIfEqual.message);
                      } else {
                        callback();
                      }
                    },
                  },
                ]
              : []),
          ],
        })(
          multiline ? (
            <Input.TextArea
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              onChange={(val) => onChange({ value: val.target.value, name })}
            />
          ) : password ? (
            <Input.Password
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              onChange={(val) => onChange({ value: val.target.value, name })}
            />
          ) : select ? (
            <Select
              loading={loading}
              mode={mode}
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              onChange={(val) => onChange({ value: val, name })}
              showSearch={options.length > 20}
            >
              {options.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          ) : number ? (
            <InputNumber
              style={{ width: "100%" }}
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              onChange={(val) => onChange({ value: val, name })}
            />
          ) : date ? (
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: "100%" }}
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              onChange={(val) => onChange({ value: val, name })}
            />
          ) : file ? (
            <SelectFile
              type={type}
              disabled={disabled}
              mountComponent={(
                { name: fileName, type: fileType, size: fileSize },
                extraProps = {}
              ) => (
                <Input
                  {...extraProps}
                  {...getInfo({
                    prefix,
                    info,
                    placeholder,
                    disabled,
                    viewOnly,
                  })}
                  prefix={
                    <Icon type="file" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  addonAfter={
                    <span style={{ color: "rgba(0,0,0,.25)" }}>
                      {![null, undefined, ""].includes(fileType) && (
                        <>
                          {`${mime.extension(fileType)}`.toUpperCase()}
                          <Divider type="vertical" />
                        </>
                      )}
                      {numeral(fileSize).format("0.0b")}
                    </span>
                  }
                  value={fileName}
                  addonBefore={prefixSelector || prefix}
                />
              )}
              onFileChange={({ value: val }) => onChange({ value: val, name })}
            />
          ) : (
            <Input
              {...getInfo({ prefix, info, placeholder, disabled, viewOnly })}
              addonBefore={prefixSelector || prefix}
              onChange={(val) => onChange({ value: val.target.value, name })}
            />
          )
        )}
      </Form.Item>
    );
  }
};

class CustomForm extends React.Component {
  static defaultProps = {
    loading: false,
    error: "",
    retry: null,
    success: "",
    fields: [],
    noLabels: false,
    labelsTop: false,
    viewOnly: false,
    rowCount: 1,
    action: { text: "Submit", type: "primary", icon: null, extra: null },
    noAction: false,
    onSubmit: () => {},
    onChange: () => {},
  };

  componentDidMount() {
    // this.props.form.validateFields();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    let {
      fields,
      action,
      noAction,
      loading,
      error,
      retry,
      success,
      onChange,
      noLabels,
      labelsTop,
      viewOnly,
      rowCount,
    } = this.props;

    let formItemLayout = {
      labelCol: {
        sm: { span: 24 },
        md: { span: 8 },
      },
      wrapperCol: {
        sm: { span: 24 },
        md: { span: 16 },
      },
    };

    let tailFormItemLayout = {
      wrapperCol: {
        sm: {
          span: 24,
          offset: 0,
        },
        md: {
          span: 16,
          offset: 8,
        },
      },
    };

    if (noLabels) {
      tailFormItemLayout = { wrapperCol: {} };
      formItemLayout = { wrapperCol: {} };
    }

    const AlertWrapper = ({ children, style = {}, labelsTop = false }) =>
      noLabels ? (
        <div style={style}>{children}</div>
      ) : (
        <Row>
          <Col
            {...(labelsTop ? {} : tailFormItemLayout.wrapperCol)}
            style={{ paddingLeft: 0, paddingRight: 0, ...style }}
          >
            {children}
          </Col>
        </Row>
      );

    const {
      getFieldDecorator,
      getFieldsError,
      getFieldValue,
    } = this.props.form;
    return (
      <Spin spinning={loading}>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          {fields.map((field, index) => (
            <Row key={index} gutter={16}>
              {Array.isArray(field) ? (
                field.map((fields_, index_) => (
                  <Col key={index_} lg={24 / rowCount}>
                    {fields_.map((field_, index_) => (
                      <Dt
                        key={index_}
                        {...field_}
                        index={index_}
                        AlertWrapper={AlertWrapper}
                        noLabels={noLabels}
                        labelsTop={labelsTop}
                        getFieldDecorator={getFieldDecorator}
                        getFieldValue={getFieldValue}
                        onChange={onChange}
                        viewOnly={viewOnly}
                      />
                    ))}
                  </Col>
                ))
              ) : (
                <Col key={index} lg={24 / rowCount}>
                  <Dt
                    {...field}
                    index={index}
                    AlertWrapper={AlertWrapper}
                    noLabels={noLabels}
                    labelsTop={labelsTop}
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    onChange={onChange}
                    viewOnly={viewOnly}
                  />
                </Col>
              )}
            </Row>
          ))}
          {!viewOnly && (
            <Row gutter={16}>
              <Col lg={24 / rowCount}>
                <AlertWrapper>
                  {success !== "" && (
                    <Alert
                      message="Success!"
                      description={success}
                      type="success"
                      showIcon
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  {error !== "" && (
                    <Alert
                      message="Error!"
                      description={error}
                      type="error"
                      showIcon
                      {...(retry
                        ? {
                            closable: true,
                            closeText: "RETRY",
                            onClose: retry,
                          }
                        : {})}
                      style={{ marginBottom: 16 }}
                    />
                  )}
                </AlertWrapper>
                {!noAction && (
                  <Form.Item
                    {...(labelsTop
                      ? { wrapperCol: { span: 24 } }
                      : tailFormItemLayout)}
                    style={{
                      textAlign: noLabels
                        ? "right"
                        : labelsTop
                        ? "right"
                        : "left",
                    }}
                  >
                    {action.extra && action.extra}
                    <Button
                      type={action.type}
                      icon={action.icon}
                      htmlType="submit"
                      loading={loading}
                      disabled={
                        action.hasOwnProperty("disabled") && action.disabled
                      }
                    >
                      {action.text}
                    </Button>
                  </Form.Item>
                )}
              </Col>
            </Row>
          )}
        </Form>
      </Spin>
    );
  }
}

export default Form.create({ name: "CustomForm" })(CustomForm);
